/** * @author ❤️❤️❤️ FightFastest 🤎🤎🤎 * @date 🚙 🚒 🛺 12/4/2022 上午 9:31 下午 1:57 🚌🚄🚈🚝 */

<template>
	<div class="name">
		<div class="name-bar"></div>
		{{ title }}
	</div>
</template>

<script>
export default {
	name: 'temp',
	props: {
		title: {
			type: String,
			default: ''
		}
	},
	data() {
		return {}
	}
}
</script>

<style scoped lang="less">
.name {
	font-size: 20px;
	display: flex;
	align-items: center;
	font-weight: bolder;
	padding: 10px 0 5px;
	.name-bar {
		display: inline-block;
		width: 3px;
		height: 20px;
		background: #009688;
		margin-right: 8px;
	}
}
</style>
